import PropTypes from 'prop-types';
import React from 'react';

const PencilFilled = ({ color }) => (
  <svg
    style={{ verticalAlign: 'middle' }}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.0228 14.7349C20.7294 14.7349 20.4915 14.9727 20.4915 15.2662V19.9837C20.4905 20.8636 19.7776 21.5768 18.8976 21.5776H3.98956C3.10958 21.5768 2.39667 20.8636 2.39563 19.9837V6.13824C2.39667 5.25847 3.10958 4.54535 3.98956 4.54431H8.70702C9.00048 4.54431 9.23833 4.30647 9.23833 4.013C9.23833 3.71974 9.00048 3.48169 8.70702 3.48169H3.98956C2.52306 3.48335 1.33467 4.67174 1.33301 6.13824V19.9839C1.33467 21.4504 2.52306 22.6388 3.98956 22.6404H18.8976C20.3641 22.6388 21.5525 21.4504 21.5541 19.9839V15.2662C21.5541 14.9727 21.3163 14.7349 21.0228 14.7349Z"
      fill={color}
      stroke={color}
      strokeWidth="0.4"
    />
    <path
      d="M21.344 2.11461C20.4103 1.18087 18.8964 1.18087 17.9627 2.11461L8.48379 11.5935C8.41883 11.6585 8.37193 11.739 8.34744 11.8274L7.10093 16.3276C7.04967 16.5121 7.10176 16.7097 7.23708 16.8452C7.37261 16.9805 7.57019 17.0326 7.75469 16.9816L12.2549 15.7348C12.3433 15.7103 12.4238 15.6634 12.4888 15.5985L21.9675 6.11936C22.8997 5.185 22.8997 3.67243 21.9675 2.73807L21.344 2.11461ZM9.64147 11.9389L17.3992 4.18091L19.9012 6.68284L12.1432 14.4408L9.64147 11.9389ZM9.1417 12.9417L11.1406 14.9408L8.37566 15.7068L9.1417 12.9417ZM21.2162 5.36806L20.6527 5.93154L18.1505 3.4294L18.7142 2.86592C19.2329 2.34727 20.0738 2.34727 20.5925 2.86592L21.2162 3.48938C21.734 4.00865 21.734 4.84899 21.2162 5.36806Z"
      fill={color}
      stroke={color}
      strokeWidth="0.4"
    />
  </svg>
);

PencilFilled.propTypes = {
  color: PropTypes.string,
};
PencilFilled.defaultProps = {
  color: '#74AA49',
};

export default PencilFilled;
